import { render, staticRenderFns } from "./DeviceVersion.vue?vue&type=template&id=c8e2600c&"
import script from "./DeviceVersion.vue?vue&type=script&lang=js&"
export * from "./DeviceVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports